import React, {useState} from 'react';
import {Box, Button, Typography} from '@material-ui/core';
import BudgetsTable from './BudgetsTable';
import BudgetCreate from './BudgetCreate';
import BudgetUsersDialog from './BudgetUsersDialog';

export default function CompaniesBudgets() {
  const [openDialog, setOpenDialog] = useState(false);
  const [budgetUserDialog, setBudgetUserDialog] = useState(false);
  const [currentEdit, setCurrentEdit] = useState({});
  const [budgetId, setBudgetId] = useState(0);

  return (
    <Box mb={2}>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography style={{fontWeight: 'bold'}} variant="subtitle1">
          Presupuestos
        </Typography>
        <Button onClick={() => setOpenDialog(true)} variant="outlined" size="small" color="primary">
          Nuevo presupuesto
        </Button>
      </Box>
      <BudgetsTable
        onEdit={(data) => {
          setCurrentEdit(data);
          setOpenDialog(true);
        }}
        onManageUsers={(id) => {
          setBudgetId(id);
          setBudgetUserDialog(true);
        }}
      />
      <BudgetCreate
        dataEdit={currentEdit}
        handleClose={() => {
          setOpenDialog(false);
          setCurrentEdit({});
        }}
        open={openDialog}
      />
      <BudgetUsersDialog
        budgetId={budgetId}
        handleClose={() => {
          setBudgetUserDialog(false);
          setBudgetId(0);
        }}
        open={budgetUserDialog}
      />
    </Box>
  );
}
